import { ChangeEvent, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { AdminRole } from '../../users/domain/Roles';

interface SelectAdminRoleDialogProps {
  adminRole: AdminRole | undefined;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (adminRole: AdminRole | undefined) => void;
}

const SelectAdminRoleDialog = (props: SelectAdminRoleDialogProps) => {
  const { isOpen, onClose, onConfirm } = props;

  // convert undefined to 'UNDEFINED' to prevent the form control value from being undefined
  const [adminRole, setAdminRole] = useState<AdminRole | 'UNDEFINED'>(
    props.adminRole || 'UNDEFINED',
  );
  console.log(adminRole);

  const handleAdminRoleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAdminRole(event.target.value as AdminRole | 'UNDEFINED');
  };

  const handleConfirm = () => {
    if (!adminRole) {
      return;
    }

    onConfirm(adminRole !== 'UNDEFINED' ? adminRole : undefined);
  };

  return (
    <Dialog
      maxWidth="sm"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Selecteer een adminrol</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormControl>
            <FormLabel>Rol</FormLabel>
            <RadioGroup
              value={adminRole}
              name="action"
              onChange={handleAdminRoleChange}
            >
              <FormControlLabel
                control={<Radio />}
                label="Superadmin"
                value="ROLE_SUPER_ADMIN"
              />
              <FormControlLabel
                control={<Radio />}
                label="Admin"
                value="ROLE_ADMIN"
              />
              <FormControlLabel
                control={<Radio />}
                label="Geen admin"
                value="UNDEFINED"
              />
            </RadioGroup>
          </FormControl>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Annuleren
        </Button>
        <Button onClick={handleConfirm} color="secondary">
          Opslaan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectAdminRoleDialog;
